export default {
        "BOT":5,
        "OWNER":4,
        "ADMIN":3,
        "STAFF":2,
        "SUPPORTER":1,
        "MEMBER":0
}


// WEBPACK FOOTER //
// ./src/modules/perms.js